import axios from 'axios'

class ProductVariantsConnector {
    /** @type{string} */
    _baseUrl

    /**
     * @param {string} middlewareUrl The url to the middleware used as base url for the endpoints.
     */
    constructor(middlewareUrl) {
        this._baseUrl = middlewareUrl
    }

    getProductVariants = async (clientId) => {
        let url = this._baseUrl
        url += '/clients/' + clientId
        url += '/products'

        return axios.get(url)
        .then(response => {
            const status = response.data.status
            const data = response.data.data

            if (status.ErrorCode != 0) {
                throw (status.ErrorMsg)
            } else {
                return data.productlist || []
            }
        })
    }

    createProductVariant = async (clientId, productVariant) => {
        let url = this._baseUrl
        url += '/clients/' + clientId
        url += '/productconfiguration'

        const body = {
            configuration: productVariant
        }

        return axios.post(url, body)
        .then(response => {
            var status = response.data.status

            if (status.ErrorCode !== 0) {
                throw (status.ErrorMsg)
            }
        })
    }

    deleteProductVariant = async (clientId, IDProduktZuordnung) => {
        let url = this._baseUrl
        url += '/clients/' + clientId
        url += '/productconfiguration/' + IDProduktZuordnung

        return axios.delete(url)
        .then(response => {
            var status = response.data.status

            if (status.ErrorCode !== 0) {
                throw (status.ErrorMsg)
            }

            return response.data?.data
        })
    }
}

export default ProductVariantsConnector